import { render, staticRenderFns } from "./deleteAffiliateVisit.vue?vue&type=template&id=c0d8544e"
import script from "./deleteAffiliateVisit.vue?vue&type=script&lang=js"
export * from "./deleteAffiliateVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports